import React from 'react'
import { DraftInvoiceList } from './DraftInvoiceList'

const OfflineInvoiceListPage: React.FC = () => {
  return (
    <div className="container mx-auto py-6">
      <DraftInvoiceList />
    </div>
  )
}

export default OfflineInvoiceListPage
